export default "__VITE_ASSET__A3eX723I__"